<div class="container">
  <app-header-actions [headerTitle]="'SECTION.MODELS'" [headerIcon]="faFlask" [config]="headerConfig"
    [initialFilters]="currentFilters" [count]="totalItems + ' ' + ('SECTION.MODELS' | translate)"
    [showCount]="true" (addClick)="onAddModel()" (filtersChanged)="onFiltersChanged($event)"
    (searchCleared)="onSearchCleared()" (tagFilterCleared)="onTagFilterCleared()"
    (allFiltersCleared)="onAllFiltersCleared()">
  </app-header-actions>

  <div class="deploy-filter" role="group" [attr.aria-label]="'MODELS.FILTER.LABEL' | translate">
    <button type="button" class="deploy-pill" [class.active]="deployFilter === 'all'"
      (click)="onDeployFilterChange('all')">
      {{ 'MODELS.FILTER.ALL' | translate }}
    </button>
    <button type="button" class="deploy-pill" [class.active]="deployFilter === 'deployed'"
      (click)="onDeployFilterChange('deployed')">
      {{ 'MODELS.FILTER.DEPLOYED' | translate }}
    </button>
    <button type="button" class="deploy-pill" [class.active]="deployFilter === 'not_deployed'"
      (click)="onDeployFilterChange('not_deployed')">
      {{ 'MODELS.FILTER.NOT_DEPLOYED' | translate }}
    </button>
  </div>

  <app-item-list [items]="modelsAsListItems" [loading]="loading" [config]="listConfig"
    [hasActiveFilters]="hasActiveFilters" (itemClick)="onItemClick($event)" (actionClick)="onActionClick($event)"
    (tagClick)="tagManager.openTagDescription($event)">
  </app-item-list>

  <app-pagination [currentPage]="currentPage" [totalPages]="totalPages" [totalItems]="totalItems" [pageSize]="pageSize"
    (pageChange)="onPageChange($event)"></app-pagination>

  <app-modal-delete-confirm [show]="showDeleteModal" [configKey]="modelToDelete?.name || ''"
    [configType]="'SECTION.MODELS' | translate" [impactItems]="modelImpactItems"
    [forceCheckboxLabel]="forceDeleteCheckboxLabel" [forceCheckboxWarning]="forceDeleteCheckboxWarning"
    (close)="onDeleteClose()" (confirm)="onDeleteConfirm($event)"></app-modal-delete-confirm>

  <app-tag-manager #tagManager entityType="models" [entityName]="'SECTION.MODELS' | translate"
    (tagChanged)="onTagChanged()">
  </app-tag-manager>

  <app-modal-deploy-model [show]="showDeployModal" [model]="selectedModelForAction" (close)="showDeployModal = false"
    (deployed)="loadModels()">
  </app-modal-deploy-model>

  <app-modal-deployment-history [show]="showHistoryModal" [model]="selectedModelForAction"
    (close)="showHistoryModal = false" (reverted)="loadModels()">
  </app-modal-deployment-history>
</div>